import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
} from "react-bootstrap";
import {
  ImFacebook,
  ImInstagram,
  ImLinkedin2,
  ImMail,
} from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import CustomButton from "./customs/CustomButton";

export default function Footer() {
 
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      // dispatch(getSubscribedAsyncThunk({ email: form["0"]?.value }));
    }
  };

  return (
    <div className="footer">
      <div className="container">
        <Row>
          <Col lg={4}>
            <div>
              <img
                className="f-logo"
                alt="img"
                src={require("../images/logo.png")}
              />
              <br />
              <br />
              <h6>
                The Dashbone Bank is a plotform to invest money and earn reward base on time and stake money
              </h6>
              <div className="social-links">
                <a href={"#"}>
                  <div className="icon">
                    <ImFacebook />
                  </div>
                </a>
                <a href={"#"}>
                  <div className="icon">
                    <ImInstagram />
                  </div>
                </a>
                <a href={"#"}>
                  <div className="icon">
                    <ImLinkedin2 />
                  </div>
                </a>
                <a href={"#"}>
                  <div className="icon">
                    <ImMail />
                  </div>
                </a>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <h3>About Us</h3>
              <Row>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Home
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Faqs
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      About Us
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Blogs
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Why Us
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Our Services
                    {/* </Link> */}
                  </h6>
                </Col>
                <Col lg={6}>
                  <h6>
                    {/* <Link className="nav nav-link" href="/"> */}
                      Contact Us
                    {/* </Link> */}
                  </h6>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <h3>Newsletter</h3>
              <h6>
                Subscribe with us to get up to date with us.
              </h6>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3 footer-mail-box">
                  <div>
                    <Form.Control
                      type="email"
                      required
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      placeholder="Enter Your Email"
                      aria-label="Enter Your Email"
                      aria-describedby="basic-addon2"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid gmail.
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="valid">
                      Looks good!
                    </Form.Control.Feedback>
                  </div>
                  <CustomButton
                    title="Submit"
                    type="submit"
                    variant="warning"
                    btnClass="createbtn"
                  />
                </Form.Group>
              </Form>
            </div>
          </Col>
        </Row>
        <div className="bottom">
          <h5>
            © Copyright {new Date().getFullYear().toString()}
            <span>Dashbone.app</span>
          </h5>
        </div>
      </div>
    </div>
  );
}
